import axios, { AxiosResponse } from "axios";
import log, { API_CALL_TIMEOUT, WAITLIST_MANAGEMENT_LIST_API_URL } from "cfg";
import { Guid } from "guid-typescript";
import { GetWaitlistManagementData, WaitlistManagementType  } from "Interfaces/WaitlistManagementInterfaces";
import { WaitlistBookResortParams, WaitlistCreateResultData } from "Interfaces/CreateWaitlist";
import timeoutPromise, { COGNITO_SSO_TOKEN, handleError, OWNER_NUMBER } from "./service.utils";
import getWaitlistManagementDataResult from './waitlist-management-results.json'
import createWaitlistResult from './create-waitlist-response.json'

// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
import { WAITLIST_API_URL, WAITLISTS_CREATE_API_URL } from "../cfg";
class WaitlistManagementService {
    static SEGMENTS = "Segments";
    getWaitlistManagementDataFake(WaitlistManagementType: WaitlistManagementType): Promise<GetWaitlistManagementData> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(getWaitlistManagementDataResult);
                let sr: any = JSON.parse(srStr);
                resolve({
                    waitlists: sr
                });
            }, 1500);
        });
    }

    getWaitlistManagementData(WaitlistManagementType: WaitlistManagementType): Promise<GetWaitlistManagementData> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        log.debug(`Cognito SSO token ${cognitoSsoToken ? 'found' : 'not found'} in the session`);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }

        const apiUrl: string = WAITLIST_MANAGEMENT_LIST_API_URL;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.getWaitlistManagementDataFake(WaitlistManagementType);
        }

        log.debug(`Calling reservation list API: ${apiUrl}`);

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "loading data for reservation list",
            axios.post(apiUrl, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': Guid.create().toString().replace('-', ''),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id': sessionStorage.read(OWNER_NUMBER)
                }
            })
                .then((resp: AxiosResponse<GetWaitlistManagementData>) => {
                    log.debug(`reservation list - response body: ${JSON.stringify(resp)}`);
                    return { waitlists: resp.data }
                }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<GetWaitlistManagementData>;
    }

    deleteWaitlistFake(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            setTimeout(() => {
                resolve({});
            }, 1500);
        });
    }
    deleteWaitlist(waitListId:number): Promise<any> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        log.debug(`Cognito SSO token ${cognitoSsoToken ? 'found' : 'not found'} in the session`);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = WAITLIST_API_URL + `/${waitListId}/cancel`;
        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === 'TRUE') {
            return this.deleteWaitlistFake();
        }

        log.debug(`Calling delete waitlist API: ${apiUrl}`);
        const savedSID = '' //sessionStorage.read(ReservationService.SEARCH_CRITERIA_SESSION_ID);
        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        const waitlistResponse: any = sessionStorage.read("WAITLIST_RESPONSE");
        return timeoutPromise(to, "deleting waitlist",
            axios.post(apiUrl, waitlistResponse,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'sessionId': savedSID,
                        'X-correlation-id': Guid.create().toString().replace('-', ''),
                        'Authorization': `Bearer ${cognitoSsoToken}`,
                        'X-Owner-Id': sessionStorage.read(OWNER_NUMBER)
                    },
                })
                .then((resp: AxiosResponse<any>) => {
                    log.debug(`response body ${JSON.stringify(resp)}`);
                    return resp.data
                }
                )
                .catch((error: any) => handleError(error, apiUrl)));
    }

    createWaitlistFake(waitllistBookResortParams :WaitlistBookResortParams): Promise<WaitlistCreateResultData> {
        return new Promise<any>(resolve => {
            setTimeout(() => {
                let srStr: string = JSON.stringify(createWaitlistResult);
                let sr: any = JSON.parse(srStr);
                resolve({
                    waitlists: sr
                });
            }, 1500);
        });
    }

    createWaitlist(waitllistBookResortParams :WaitlistBookResortParams): Promise<WaitlistCreateResultData> {
        const cognitoSsoToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        log.debug(`Cognito SSO token ${cognitoSsoToken ? 'found' : 'not found'} in the session`);
        if (!cognitoSsoToken || cognitoSsoToken === 'null' || cognitoSsoToken === 'undefined') {
            return Promise.reject({ code: 401});
        }
        const apiUrl: string = WAITLISTS_CREATE_API_URL;

        //return this.createWaitlistFake(waitllistBookResortParams);

        //in case we do not want to make actual API calls we can just configure it to work with fake data
        if (process.env.REACT_APP_USE_FAKE_REQS === '%TRUE') {
            return this.createWaitlistFake(waitllistBookResortParams);
        }

        log.debug(`Calling create waitlist API: ${apiUrl}`);

        //currently Experience API is very slow , so we give it a long wait before it times out
        const to = API_CALL_TIMEOUT ? parseInt(API_CALL_TIMEOUT) : 20000;

        return timeoutPromise(to, "CREATING A WAITLIST",
            axios.post(apiUrl, waitllistBookResortParams, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-correlation-id': Guid.create().toString().replace('-', ''),
                    'Authorization': `Bearer ${cognitoSsoToken}`,
                    'X-Owner-Id': sessionStorage.read(OWNER_NUMBER)
                }
            })
                .then((resp: AxiosResponse<WaitlistCreateResultData>) => {
                    log.debug(`create waitlist - response body: ${JSON.stringify(resp)}`);
                    return { waitlists: resp.data }
                }
                )
                .catch((error: any) => handleError(error, apiUrl))) as Promise<WaitlistCreateResultData>;
                
    }

}



export default WaitlistManagementService;